var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import CatalogMemberFactory from "../../Models/Catalog/CatalogMemberFactory";
import modelReferenceArrayTrait from "../Decorators/modelReferenceArrayTrait";
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import { ItemPropertiesTraits } from "./ItemPropertiesTraits";
let GroupTraits = (_dec = primitiveArrayTrait({
  name: "Exclude members",
  type: "string",
  description: "An array of strings of excluded group and item names (or ids). A group or item name (or id) that appears in this list will not be shown to the user. This is case-insensitive and will also apply to all child/nested groups"
}), _dec2 = primitiveTrait({
  name: "Include members by regular expression",
  type: "string",
  description: "A regular expression that is matched against the member names and ids. Only members (groups and items) that match against the regular expression will be shown to the user. This is case-insensitive and will only apply to the first level of members (not in nested groups). This is applied before excludeMembers."
}), _dec3 = primitiveTrait({
  name: "Is Open",
  description: "True if this group is open and its contents are visible; otherwise, false.",
  type: "boolean"
}), _dec4 = primitiveTrait({
  name: "Merge by name",
  description: "Merge member groups by name.",
  type: "boolean"
}), _dec5 = primitiveTrait({
  name: "Sort members by",
  description: "Sort members by the given property/trait. For example `name`, will sort all members by alphabetically",
  type: "string"
}), _dec6 = modelReferenceArrayTrait({
  name: "Members",
  description: "The members of this group.",
  factory: CatalogMemberFactory
}), _dec7 = primitiveTrait({
  name: "Display group",
  description: "Allow adding all members to the workbench with one click. Show Add All / Remove All button",
  type: "boolean"
}), _class = class GroupTraits extends mixTraits(ItemPropertiesTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "excludeMembers", _descriptor, this);
    _initializerDefineProperty(this, "includeMembersRegex", _descriptor2, this);
    _initializerDefineProperty(this, "isOpen", _descriptor3, this);
    _initializerDefineProperty(this, "mergeGroupsByName", _descriptor4, this);
    _initializerDefineProperty(this, "sortMembersBy", _descriptor5, this);
    _initializerDefineProperty(this, "members", _descriptor6, this);
    _initializerDefineProperty(this, "displayGroup", _descriptor7, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "excludeMembers", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "includeMembersRegex", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isOpen", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "mergeGroupsByName", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sortMembersBy", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "members", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "displayGroup", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { GroupTraits as default };